import { NgModule } from '@angular/core';
import { SortHeaderComponent } from './sort-header.component';
import { CommonModule } from '@angular/common';
@NgModule({
  imports: [CommonModule],
  declarations: [SortHeaderComponent],
  exports: [SortHeaderComponent],
})
export class SortHeaderModule {
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/common/sort-header/sort-header.module.ts